import { createNativeStackNavigator } from "@react-navigation/native-stack";
import OnboardingScreen from "../screens/onboardingscreen";
import LoginScreen from "../screens/loginscreen";
import { Platform } from "react-native";
import { pageTitle } from "../context/helper";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const Stack = createNativeStackNavigator();

const AuthStack = () => {
  const { isService } = useContext(AuthContext);

  const showOnboarding = () => Platform.OS !== "web" && !isService;

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {showOnboarding() && (
        <Stack.Screen
          component={OnboardingScreen}
          name="Onboarding"
          options={{ title: pageTitle("Start") }}
        />
      )}
      <Stack.Screen
        component={LoginScreen}
        name="Login"
        options={{ title: pageTitle("Login") }}
      />
    </Stack.Navigator>
  );
};

export default AuthStack;
